import { generateUniqueId } from '@/helpers/uuidUtils';

export class AccessoryService {
  id: string;
  timestamp: string;
  type?: string;
  reason?: string;
  accessoryId?: string;
  newAccessoryId?: string;
  isExchangedAdapter: boolean;
  note?: string;

  constructor() {
    this.id = generateUniqueId();
    this.type = undefined;
    this.reason = undefined;
    this.timestamp = new Date().toISOString();
    this.accessoryId = undefined;
    this.newAccessoryId = undefined;
    this.isExchangedAdapter = false;
    this.note = undefined;
  }

  setAccessoryId(id: string | undefined) {
    this.accessoryId = id;
    return this;
  }

  setNewAccessoryId(id: string) {
    this.newAccessoryId = id;
    return this;
  }

  setReason(reason: string | undefined) {
    this.reason = reason;
    return this;
  }

  setType(type: string | undefined) {
    this.type = type;
    return this;
  }
}
